import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {DrawnCard} from '@/app/core/models/collection/drawn-card.model';
import {Booster} from '@/app/core/models/collection/booster';

@Injectable({
	providedIn: 'root'
})
export class BoosterService {

	private readonly SERVICE_URI = `${environment.backendUrl}/boosters`;

	private readonly http: HttpClient = inject(HttpClient);

	/** Achète et ouvre `quantity` boosters PEPS d'un coup (débit atomique du coût total côté serveur). */
	purchaseBooster(boosterId: string, quantity: number = 1): Observable<DrawnCard[]> {
		const params = new HttpParams().set('quantity', quantity);
		return this.http.post<DrawnCard[]>(`${this.SERVICE_URI}/purchase/${boosterId}`, {}, {params});
	}

	openBooster(boosterId: string): Observable<DrawnCard[]> {
		return this.http.post<DrawnCard[]>(`${this.SERVICE_URI}/open/${boosterId}`, {});
	}

	getBoosters(): Observable<Booster[]> {
		return this.http.get<Booster[]>(`${this.SERVICE_URI}/shop`);
	}
}
